import React from 'react';

export const Overdue = () => {
    return (
        <svg
            width="15"
            height="14"
            viewBox="0 0 15 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="0.5" width="14" height="14" rx="7" fill="white" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.24549 3.74549C4.3627 3.62832 4.52164 3.5625 4.68737 3.5625C4.85309 3.5625 5.01204 3.62832 5.12924 3.74549L7.49987 6.11612L9.87049 3.74549C9.92815 3.6858 9.99711 3.63818 10.0734 3.60543C10.1496 3.57267 10.2316 3.55543 10.3146 3.55471C10.3976 3.55399 10.4799 3.5698 10.5567 3.60123C10.6335 3.63265 10.7033 3.67906 10.762 3.73775C10.8207 3.79643 10.8671 3.86621 10.8985 3.94302C10.9299 4.01983 10.9457 4.10213 10.945 4.18512C10.9443 4.26811 10.9271 4.35012 10.8943 4.42637C10.8615 4.50262 10.8139 4.57159 10.7542 4.62924L8.38362 6.99987L10.7542 9.37049C10.8681 9.48837 10.9311 9.64625 10.9297 9.81012C10.9282 9.97399 10.8625 10.1307 10.7466 10.2466C10.6307 10.3625 10.474 10.4282 10.3101 10.4297C10.1462 10.4311 9.98837 10.3681 9.87049 10.2542L7.49987 7.88362L5.12924 10.2542C5.01137 10.3681 4.85349 10.4311 4.68962 10.4297C4.52574 10.4282 4.36898 10.3625 4.2531 10.2466C4.13722 10.1307 4.07149 9.97399 4.07007 9.81012C4.06865 9.64625 4.13164 9.48837 4.24549 9.37049L6.61612 6.99987L4.24549 4.62924C4.12832 4.51204 4.0625 4.3531 4.0625 4.18737C4.0625 4.02164 4.12832 3.8627 4.24549 3.74549Z"
                fill="#DF989C"
            />
        </svg>
    );
};
